import { EndpointDetailsWebComponent } from './component/EndpointDetailsWebComponent';
import { WEB_COMPONENT_ENDPOINT_DETAILS } from '../webcomponents.constants';

export { EndpointDetailsWebComponent };

window.customElements.define(WEB_COMPONENT_ENDPOINT_DETAILS, EndpointDetailsWebComponent);
